export default function ({
  route,
  redirect,
  app
}) {
  if (route.query.type === 'freeLogin') {
    return
  }

  const ssoToken = app.$cookies.get('SSOTOKEN')
  if (ssoToken && ssoToken !== 'undefined') {
    return
  }

  redirect('/')
}
